// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__Kd2KD","logoText":"Logo_logoText__4IH4S"};